import { MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { req } from "./ServerUtils";

export function SetDesignerWidget({designer, setDesigner}) {
    const [emails, setEmails] = useState([]);

    useEffect(() => {
        req('/admin/designers').then(designers => setEmails(designers));
    }, [])

    return (
        <div>
            <Select fullWidth size="small" value={designer} onChange={(e) => setDesigner(e.target.value)}>
                {emails.map((email, i) => (
                    <MenuItem key={i} value={email}>{email}</MenuItem>
                ))}
            </Select>
        </div>
    )
}